import { BmHttp } from "../utils/Global";
import { notifyCitaFinalizada, CITA_FINALIZADA_SENTINEL } from "../utils/citaFinalizadaAlert";


export const createCitaPaciente = async (cita) => {
    try {
        const { data } = await BmHttp().post('create_cita', cita)
        return data
    } catch (error) {
        console.log(error);
        // LOCK-CITA-FINALIZADA-26: create_cita ahora puede responder el mismo
        // 409 "cita finalizada" que ya manejan otras pantallas clinicas (ver
        // utils/citaFinalizadaAlert.js) -- reutiliza el mismo aviso (toast) en
        // vez de dejar que caiga en el mensaje generico de abajo. El sentinel
        // le indica al caller (GestionCitas.js) que omita su propio Swal --
        // mismo patron ya usado en Service.examen.js/Service.certificados.js.
        if (notifyCitaFinalizada(error)) return CITA_FINALIZADA_SENTINEL;
        // CITAS-PROCEDIMIENTOS-02: create_cita ahora puede responder 403/404/422
        // (validacion de scope/tarifario/duplicados de CITAS-PROCEDIMIENTOS-01) --
        // antes este catch devolvia undefined y el mensaje especifico del
        // backend se perdia. Se propaga error.response.data (mismo patron ya
        // usado en Service.porcedimientos.js) para no degradar a un mensaje
        // generico cuando el backend ya trae uno util.
        return (
            error.response?.data || {
                success: false,
                message: "No se pudo guardar la cita. Intente nuevamente.",
            }
        );
    }
}

export const ListarCitaClinica = async (idclinica) => {
    try {
        const { data } = await BmHttp().get(`get_citas?idclinica=${idclinica}`)
        return data
    } catch (error) {
        console.log(error);
    }
}

export const ActualizarCita = async (cita) => {
    try {
        const { data } = await BmHttp().post('up_cita', cita)
        return data
    } catch (error) {
        console.log(error);
    }
}

export const ActualizarEstadoCita = async (cita) => {
    try {
        const { data } = await BmHttp().post('up_estado_cita', cita)
        return data
    } catch (error) {
        console.log(error);
    }
}

export const EliminarCita = async (idcita) => {
    try {
        //const { data } = await BmHttp().delete('get_citas?idcita='+idcita)
        const { data } = await BmHttp().delete('get_citas', { params: { idcita: idcita } })

        return data
    } catch (error) {
        console.log(error);
    }
}

export const ControllerListarCitasClinicas = async (fecha_inicio, fecha_fin) => {
    try {
        const { data } = await BmHttp().get(`get_citas_clinica?fecha_inicio=${fecha_inicio}&fecha_fin=${fecha_fin}`)
        return data
    } catch (error) {
        console.log(error);
    }
}

export const ControllerCitaPaciente = async (idpaciente, idcita) => {
    try {
        const { data } = await BmHttp().get(`get_citas_paciente?idpaciente=${idpaciente}&idcita=${idcita}`)
        return data
    } catch (error) {
        console.log(error);
    }
}

// Signos vitales
export const ControllerListarUltimoSignosVitales = async (idcita) => {
    try {
        const { data } = await BmHttp().get(`signosvitales_one/signosvitales_one?idcita=${idcita}`)
        return data
    } catch (error) {
        console.log(error);
    }
}

export const ControllerUpadateCreateSignosVitales = async (signosvitales) => {
    try {
        const { data } = await BmHttp().post('signosvitales_create', signosvitales)
        return data
    } catch (error) {
        notifyCitaFinalizada(error);
        console.log(error);
    }
}

export const ControllerListarCitaId = async (idcita) => {
    try {
        const { data } = await BmHttp().get(`get_citas_id?idcita=${idcita}`)
        return data
    } catch (error) {
        console.log(error);
    }
}
/* INI - Para poder encadenar procedimientos de facturas con el idcita que corresponde */

export const ListarFacturasPendientesPaciente = async (idpaciente) => {
    try {
        const { data } = await BmHttp().get(`get_facturas_pendientes?idpaciente=${idpaciente}`);
        return data;
    } catch (error) {
        console.log(error);
    }
};
/* FIN - Para poder encadenar procedimientos de facturas con el idcita que corresponde */

// CITAS-VISTA-MEDICO: la agenda del médico que ha iniciado sesión. NO recibe
// iddoctor -- el backend lo saca del token (`doctores.user_id`), que es lo que
// impide pedir la agenda de otro. Ver /mi_agenda en el backend.
export const ObtenerMiAgenda = async (fecha, idespecialidad) => {
    try {
        const params = new URLSearchParams({ fecha });
        if (idespecialidad) params.set("idespecialidad", String(idespecialidad));
        const { data } = await BmHttp().get(`mi_agenda?${params.toString()}`);
        return data;
    } catch (error) {
        console.log(error);
        return { success: false, data: null, message: "No se pudo cargar tu agenda" };
    }
}

// CITAS-CONTEO-ESPECIALIDAD: cuántas citas tiene cada especialidad ese día,
// para el rail de /gestion_citas. Agregado puro -- una fila por especialidad
// con su total, nunca datos de pacientes.
export const ContarCitasPorEspecialidad = async (fecha) => {
    try {
        const { data } = await BmHttp().get(`citas/conteo-especialidad?fecha=${fecha}`);
        return data;
    } catch (error) {
        // Que falle el conteo NO debe romper la agenda: el rail se pinta sin
        // números y la pantalla sigue funcionando igual.
        console.log(error);
        return { success: false, data: [] };
    }
}
